import React from 'react';

/**
 * GolfSwingIcon - SVG icon of a golfer in finish position
 * Clean, monoline style suitable for app branding
 */
export function GolfSwingIcon({ size = 24, className = '', color = 'currentColor' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Head */}
      <circle cx="8" cy="4" r="2" />

      {/* Body - torso rotated in follow-through */}
      <path d="M8 6 L10 12 L8 18" />

      {/* Arms - extended in finish position */}
      <path d="M10 8 L16 4 L20 2" />

      {/* Club */}
      <path d="M16 4 L18 6" strokeWidth="2" />

      {/* Back leg - planted */}
      <path d="M8 18 L6 22" />

      {/* Front leg - rotated through */}
      <path d="M10 14 L12 22" />

      {/* Ball flight arc (optional decorative) */}
      <path
        d="M20 3 Q22 1 24 2"
        strokeWidth="1"
        strokeDasharray="2 2"
        opacity="0.5"
      />
    </svg>
  );
}

export default GolfSwingIcon;
